export enum EAppInitialStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
}

export interface TAmazonFile {
  id: string;
  file: File;
  fileError?: File;
  uploadProgress: number | null;
  isUploading: boolean;
  errorMessage: string;
}

export interface IError {
  error?: { message: string };
}

export interface IResponse<T = { [name: string]: any }> extends IError {
  count: number;
  data: T[];
}

export interface IAppSettings {
  leaveRequestOptions: { label: string; value: any }[];
  applicationOptions: { label: string; value: any }[];
  meetingTemplates: { label: string; value: any }[];
}
